import { useCallback, useMemo } from 'react';
import { useExperiments, useExposureEvent } from '@alltrails/experiments';

const useNaturalLanguageSearchExperiment = () => {
  const experiments = useExperiments();
  const sendExposure = useExposureEvent('web-ai-natural-language-search');

  const onInputFocus = useCallback(() => {
    sendExposure();
  }, [sendExposure]);
  const isNaturalLanguageSearchEnabled = experiments['web-ai-natural-language-search']?.value === 'treatment';

  return useMemo(
    () => ({
      isNaturalLanguageSearchEnabled,
      onInputFocus
    }),
    [isNaturalLanguageSearchEnabled, onInputFocus]
  );
};

export default useNaturalLanguageSearchExperiment;
